import compact from "lodash/compact";
export default (edge) => { var _a; return compact(((_a = edge.tag) === null || _a === void 0 ? void 0 : _a.Edges) ? edge.tag.Edges : [edge.tag]); };
